import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from '@doxyme/ui';
import { FormattedMessage } from 'react-intl';
export const RemoveFromActiveModal = ({ isOpen, onCancel, onRemove, }) => {
    return (<Modal className="teleconsent-remove-from-active-modal" isOpen={isOpen}>
      <ModalHeader onClose={onCancel}>
        <FormattedMessage tagName="h4" id="account.administration.teleconsent.remove-from-active.title" defaultMessage="Remove template"/>
      </ModalHeader>
      <ModalBody>
        <div data-testId="remove-modal-description">
          <FormattedMessage id="account.administration.teleconsent.remove-from-active.text" defaultMessage="Remove access to this template for any providers who currently have access. The template will still be available in your template manager."/>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="ui-modal-actions">
          <Button size="medium" onClick={onCancel} btnStyle="outline" color="secondary" data-testId="remove-modal-cancel-btn">
            <FormattedMessage id="account.administration.teleconsent.remove-from-active.cancel" defaultMessage="Cancel"/>
          </Button>
          <Button size="medium" onClick={onRemove} className="call-overlay__camera" data-testId="remove-modal-remove-btn">
            <FormattedMessage id="account.administration.teleconsent.remove-from-active.remove" defaultMessage="Remove"/>
          </Button>
        </div>
      </ModalFooter>
    </Modal>);
};
